class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.announcementBar = this;
    this.closeButton = this.querySelector('[data-close-announcement-button]');

    this.storageKey = 'announcementClosed';

    this.close = this.close.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.init = this.init.bind(this);
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (sessionStorage.getItem(this.storageKey) === 'true') {
      this.close();
      return;
    }

    this.closeButton.addEventListener('click', this.handleClick);
  }

  handleClick() {
    sessionStorage.setItem(this.storageKey, 'true');
    this.close();
  }

  close() {
    this.announcementBar.classList.add('hidden');
    window.HeaderGroupSpacer.dispatchHeaderHeight();
  }
}

customElements.define('announcement-bar', AnnouncementBar);
